// import Udesk from 'Udesk';
import uploadDownComponent from './component';

class uploadDownRoute extends uploadDownComponent {}

export default uploadDownRoute;
